import React from "react";
import { Redirect } from 'react-router-dom';
import RegistrationForm from './../Forms/RegistrationForm.jsx';
import { Routes } from './../Core/Constants';

export default class Registration extends React.Component {
	state = {
		success:false
	}
	handleSuccessRegistration = () => {
		window.gtm.onRegistration('login');
		this.setState({ success: true });
	}
	
	render() {
		var T = window.Texts.registration;
		if (this.state.success)
			return <Redirect to={Routes.SucessRegistration} />;

		return (
			<div className="custommer-registration-page">
				<div className="cover">
					<div className="headline">
						<h1>{T.title}</h1>
					</div>
					<div className="inner-750">
						<RegistrationForm onSuccess={()=>this.handleSuccessRegistration()} />
					</div>
				</div>
			</div>
		);
	}
}

